/**
 * Takes item from list and overwrite another field with list containing it
 * @param {String} params.from - name of the origin field
 * @param {String} params.to - field where item is copied
 * @param {String} [params.index=0] - index of item your copying
 */
export const setValue = function (params: any, schema: any, uiSchema: any, formData: any) {
  const { source = "", target, } = params;

  const [first, second] = source.split(".");
  let value;

  if (first) {
    value = formData[first]
  };

  if (second && value && typeof value === "object") {
    value = value[second]
  }

  formData[target] = value

};


// Action validation
if (process.env.NODE_ENV !== 'production') {


}